import React from 'react'
import AddNewEmailTemplate from '../../../features/FiledManagement/EmailTemplateManagement/AddNewEmailTemplate';
const AddEmailTemplate = () => {

    return (
        <div>
            <AddNewEmailTemplate/>
        </div>
    )

}

export default AddEmailTemplate